// 文件上传接口
import {request_async} from "@/utils/requestAsync";
import {API_URL_ERP} from "@/model/ConfigModel"

// 获取七牛云上传token
export async function getQiNiuToken(bucket) {
  return request_async(API_URL_ERP + `v1/upload/qiniuToken?bucket=${bucket}`, "get", '');
}

